import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button, PageEmptyState } from 'seagull';
import { Plus } from 'seagull/icons';
import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { CommonServicesPage } from '../CommonServicesPage/CommonServicesPage';
import { ColumnId, bulkImportRoute } from '../CommonServicesPage/CommonServicesPage.utils';
import EmptyServices from '../emptyServices.svg';
import ServiceLibrarySeeWhatItsLike from './SeeWhatItsLike/SeeWhatItsLike';
const baseColumnDefs = [
    {
        width: [
            200,
            400
        ],
        sortable: true
    },
    {
        width: 130,
        sortable: true
    },
    {
        width: 120,
        sortable: true
    },
    {
        width: 110,
        sortable: true
    }
];
export const importServicesRoute = bulkImportRoute('services');
const baseHeaderItems = [
    {
        value: 'Service name',
        id: ColumnId.Name
    },
    {
        value: 'Rate',
        id: ColumnId.Rate
    },
    {
        value: 'Billing occurrence',
        id: ColumnId.BillingOccurance
    },
    {
        value: 'Billing trigger',
        id: ColumnId.BillingTrigger
    }
];
export function ServicesPage() {
    const importServicesLink = useStore(selectors.filterAvailableRoutes([
        importServicesRoute
    ]))[0];
    const { fetchServiceTemplates } = useStoreActions();
    function renderEmptyState(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsx(PageEmptyState, {
            testId: "services-empty",
            illustration: /*#__PURE__*/ _jsx(EmptyServices, {}),
            title: "Organize Your Business with Services",
            message: "Make the process of managing new proposals easier by adding services. You can always create new services, edit or delete existing ones in the future.",
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(ServiceLibrarySeeWhatItsLike, {}),
                    /*#__PURE__*/ _jsx(Button, {
                        testId: "service-library-new-btn",
                        onClick: ()=>openBuilder(),
                        children: "Create a service"
                    })
                ]
            })
        });
    }
    function renderHeaderActions(param) {
        let { openBuilder } = param;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                importServicesLink && /*#__PURE__*/ _jsx(Button, {
                    skin: "primaryOutline",
                    as: Link,
                    to: importServicesLink.url,
                    children: importServicesLink.text
                }),
                /*#__PURE__*/ _jsx(Button, {
                    prefixIcon: /*#__PURE__*/ _jsx(Plus, {
                        height: 18,
                        width: 18
                    }),
                    testId: "service-library-new-btn",
                    onClick: ()=>openBuilder(),
                    children: "New service"
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(CommonServicesPage, {
        title: "Services",
        subtitle: "Create and manage the services you provide to clients. You may customize the services per client when generating each new proposal.",
        columnDefs: baseColumnDefs,
        headerItems: baseHeaderItems,
        fetchMethod: fetchServiceTemplates,
        renderEmptyState: renderEmptyState,
        headerActions: renderHeaderActions,
        dataSelector: (state)=>state.serviceTemplates
    });
}
